/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
 $('body').on('DOMSubtreeModified', '#delivery_timer_wrapper', function(){
    setTimeout(function() {
     var text =   jQuery('#delivery_timer_wrapper').html();  
     jQuery('.order-notes').html(text);
     jQuery('#delivery_timer_wrapper-dup').html(text);
     
    }, 500)
 });

  jQuery(document).ready(function(){
    // hide table in description
    jQuery('#description table').hide();
    
    // get the ul li move to highlights
    var high = jQuery('#description ul').html();
    jQuery('#description ul,#description p strong').hide();
    jQuery('.key_features ul').append(high);
    jQuery('.paypal-credit img').hide();
    jQuery('.paypal-credit img').click(function(){
  	jQuery('.shopify-cleanslate div').trigger('click');
  });

  });


jQuery('.color-swatch').click(function(){
var checker = jQuery('.product-form__payment-container .product-form__add-button').text();
 if( checker == 'Sold out'){
  $('#out-stocks,.order-notes-info').attr("style", "display: none !important"); 
  $('#delivery_timer_wrapper-dup,.order-notes').attr("style", "display: block !important");
console.log('sold out');
}else{
  $('#out-stocks,.order-notes-info').attr("style", "display: block !important");
  $('#delivery_timer_wrapper-dup,.order-notes').attr("style", "display: none !important");
console.log('cart');
}
})

if (/Mobi|Android/i.test(navigator.userAgent)) {
  $('div#shopify-section-text-with-icons-header  p.text-with-icons__title').each(function() {
      var text = $(this).text();
      $(this).text(text.replace('Available', ' ')); 
  });


}

